import React, { Component } from 'react'
import { Container, Row, Col,Button } from "reactstrap";
import {connect} from "react-redux"
import { Link } from "react-router-dom";
import {viewPublishJobsAction,searchApplyJobs} from "../../redux/action/jobs/publish_jobsAction"
import ErrorNotifier from '../aside/ErrorNotifier';
import Notifier from '../aside/Notifier';
import ParticularPublishedJobs from './particularPublishedJobs';

 class Jobs extends Component {
   constructor(props){
    super(props)
     this.state = {
      edit:false,
      storeData:[],
      searchValue:"",
      errorSearch:"" 
     }
     this.handleViewClick = this.handleViewClick.bind(this)
     this.backNavigate = this.backNavigate.bind(this)
     this.searchChange = this.searchChange.bind(this)
     this.searchClick = this.searchClick.bind(this)
   }
    
    componentDidMount(){
    this.props.viewPublishJobsAction()
    }

    
    handleViewClick(data){
      this.setState({
      isEdit:!this.state.isEdit,     
      storeData:[data],
      })
   }
  
    backNavigate(){
      this.setState({
      isEdit:false,     
       })
    }

    searchChange(e){
      if(!e.target.value){
      this.props.viewPublishJobsAction()  
      }
    this.setState({
      [e.target.name]:e.target.value,
      errorSearch:""
    })
    }
    searchClick(){
      if(this.state.searchValue){
        let body = {
          search:this.state.searchValue
        }
      this.props.searchApplyJobs(body)
      }
      else {
       this.setState({
         errorSearch:"Please enter keyword to search"
       })
      }
     
    }

    render() {
      console.log(this.props.viewPublishJobs)
        return (
            <Container
            style={{ width:"80%", marginTop: "90px !important" }}
            className="card container-card migrator-mt personalDetails-div-1 scrollmenu"
          >
           < Link to ="/dashboard">
           <i
              className="material-icons contact-cancel-button pointer"
            //   onClick={this.props.back}
            >
              cancel
            </i>
           </Link>
           
          { !this.state.isEdit &&  <div
            style={{
              height: "50px",
              width: "60%",
              margin: "auto",
              marginTop: "1rem",
            }}
            class="search-container"
          >
            <div style={{ display: "flex", height: "100%", width: "100%" }}>
              <input
                className="input-candisearch"
                value={this.state.searchValue}
                name="searchValue"
                style={{ width: "100%", height: "100" }}
                onChange={this.searchChange}
                onKeyPress={(e) => {
                  if (e.code === "Enter") {
                  this.searchClick();
                  }
                  }}
                type="text"
                placeholder="Search.."
              
              />
              <button
                onClick={this.searchClick}
                style={{ border: "none", background: "green", width: "80px" }}
                type="submit"
              >
                <i style={{ color: "white" }} class="fa fa-search"></i>
              </button>
            </div>
            <span style={{ fontSize: "14px", color: "red" }}>
              {this.state.errorSearch}
            </span>
            {/* <span style={{ fontSize: "14px", color: "red" }}>
              {isAvailable}
            </span>  */}
          </div>}
            
            <Row style={{marginTop:"1rem"}} >
          {/* { !this.state.isEdit &&  <div style={{width:"100%",display:"flex",fontSize:"1.2rem",justifyContent:"center"}}>
           <span>View Published Jobs</span>
           </div>  } */}

{/* { !this.state.isEdit && <div style={{display:'flex'}}>
<ul  style={{display:'flex',width:'100%',justifyContent:'space-between'}}>
  <li>
    Id
  </li>
  <li>
  Req Id
  </li>
  <li>
  Job Category
  </li>
  <li>
  Job Position
  </li>
  <li>
  Job Location
  </li>
  <li>
  Experience
  </li>
  <li>
  Skills
  </li>
  <li>
  Qualification
  </li>
</ul>

</div>} */}


           
           { !this.state.isEdit && <Col md="12" className="p-0">
              <ul className="crm-flex-around  ul-head ">
                <li
                  style={{ width: "10%",fontSize: "14px",
                  fontWeight: "500", }}
                  className="list-crm-item bold pad-rs-name margin_res"
                >
                   Id
                </li>
                <li  style={{fontSize: "14px",
                  fontWeight: "500",width:"10%" }} className="list-crm-item bold pad-rs-name margin_res"> Req Id</li>
                <li  style={{fontSize: "14px",
                  fontWeight: "500", }} className="list-crm-item bold pad-rs-name margin_res">Job Category </li>
               
                <li  style={{fontSize: "14px",
                  fontWeight: "500", }} className="list-crm-item bold pad-rs-name margin_res"> Job Position</li>

                <li  style={{fontSize: "14px",
                  fontWeight: "500", }} className="list-crm-item bold pad-rs-name margin_res">Job Location</li>
                
                <li  style={{fontSize: "14px",
                  fontWeight: "500", }} className="list-crm-item bold pad-rs-name margin_res"> Experience</li>

                <li style={{
                        fontSize: "14px",
                      fontWeight: "500",
                    }} className="list-crm-item bold pad-rs-name margin_skills margin_res"> Skills</li>
                <li
                style={{
            
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  className="list-crm-item bold pad-rs-name"
                >
                  {" "}
                  Qualification
                </li>
              </ul>
            </Col>}
           { !this.state.isEdit && this.props.viewPublishJobs.data.length > 0 &&
               this.props.viewPublishJobs.data.map((item) => {
                return (
                  <Col md="12" className="p-0" key={item.id}>
                    <ul
                      onClick={() => this.handleViewClick(item)}
                      className="rs-flex-around margin_ul"
                      // onClick={() => {
                      //   select(item);
                      // }}

                      // onMouseEnter={(e) => this.toggleHoverOn(e, item)}
                      // onMouseLeave={this.toggleHoverOff}
                    >
                      <li
                        style={{ width: "10%", paddingLeft: "2%" }}
                        className="list-crm-table-item pad-rs-name margin_res margin_id overlap_text"
                      >
                        {item.id}
                      </li>
                      <li
                        style={{ width: "10%", paddingLeft: "2%" }}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobRequirementId}
                      </li>
                      <li
                      style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobCategory}
                      </li>
                     
                      <li
                        style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobPosition}
                      </li>

                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobLocation}
                      </li>
                     
                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.minYearsOfExp}
                      </li>
                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res  overlap_text" 
                      >
                        {item.primarySkills}
                      </li>
                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.qualifications}
                      </li>
                    </ul>
                  </Col>
                );
              })}
          </Row>
          {this.props.ApplyJobs.message ? (
          <Notifier message={this.props.ApplyJobs.message} />
        ) : null}

       {this.props.ApplyJobs.error ? (
          <ErrorNotifier message={this.props.ApplyJobs.error} />
        ) : null}
        
          {
          this.state.isEdit && <ParticularPublishedJobs back ={this.backNavigate} storeData = {this.state.storeData}/>
          }
           {this.props. viewPublishJobs.message && <ErrorNotifier message={this.props.viewPublishJobs.message} />}
          </Container>
        )
    }
}

const mapStateToProps = (state) =>({
  viewPublishJobs:state.viewPublishJobs,
  ApplyJobs: state.ApplyJobs,
})




// export default connect(null,mapStateToProps,{
//   viewPublishJobsAction
// })(Jobs)

export default connect(mapStateToProps, { viewPublishJobsAction,searchApplyJobs  })(
  Jobs
);
